// extracted by mini-css-extract-plugin
export default {"socials":"socials_socials__o91pE","socials_container":"socials_socials_container__7aBf+","mobile":"socials_mobile__bdGh5","desktop":"socials_desktop__jOX65"};